import { RootState, DeviceState, Module } from '../types'
import { Device, DriverDictionary, Driver } from '@/types/device'

import { Find, FindDriver } from '@/api/device'

export const device: Module<DeviceState, RootState> = {
  namespaced: true,
  state() {
    return {
      items: [],
      drivers: {} as DriverDictionary,
    }
  },

  getters: {},

  mutations: {
    // eslint-disable-next-line
    SET_ITEMS(state, devices: Device[]) {
      state.items = devices
    },

    SET_DRIVERS(state, drivers: Driver[]) {
      for (const d of drivers) {
        state.drivers[d.name] = d
      }
    },
  },

  actions: {
    async findDevices({ commit }) {
      const devices = await Find()
      commit('SET_ITEMS', devices)
    },

    async findDrivers({ commit }) {
      const drivers = await FindDriver()
      commit('SET_DRIVERS', drivers)
    },
  },
}
